import React, { useState } from "react";
import "./styles.scss";
import moment from "moment";
import { GetIconByName } from "../../config/icon";
import {
  changeCommentLike,
  deleteNewsComment,
  updateNewsCommentStatus,
} from "../../containers/news/service/news.service";
import { Popconfirm } from "antd";
import { Store } from "react-notifications-component";

const CommentItem = ({ comment, newsId, index, type, refresh }) => {
  const [likes, setLikes] = useState(comment?.likes || 0);
  const [dislikes, setDislikes] = useState(comment?.dislikes || 0);
  const [showReplyBox, setShowReplyBox] = useState(false);

  const commentKey = `comment_reaction_${comment?.comment_id}`;

  const handleLike = async () => {
    const alreadyReacted = localStorage.getItem(commentKey);
    if (alreadyReacted) {
      alert("You have already rated this comment.");
      return;
    }
    try {
      const response = await changeCommentLike(
        "like",
        comment?.comment_id,
        newsId
      );
      console.log("add News Comments::", response);
      if (response.data?.status) {
        setLikes(likes + 1);
        localStorage.setItem(commentKey, "liked");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDislike = async () => {
    const alreadyReacted = localStorage.getItem(commentKey);
    if (alreadyReacted) {
      alert("You have already rated this comment.");
      return;
    }
    try {
      const response = await changeCommentLike(
        "dislike",
        comment?.comment_id,
        newsId
      );
      console.log("add News Comments::", response);
      if (response.data?.status) {
        setDislikes(dislikes + 1);
        localStorage.setItem(commentKey, "disliked");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onclickHide = async () => {
    try {
      const response = await updateNewsCommentStatus(
        "hide",
        comment?.comment_id,
        newsId
      );
      console.log("add News Comments::", response);
      if (response.data?.status) {
        refresh(true);
      }
    } catch (error) {
      Store.addNotification({
        title: "Error!",
        message: "Comment hiding Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      console.error(error);
    }
  };

  const onClickDelete = async () => {
    try {
      const response = await deleteNewsComment(comment?.comment_id, newsId);
      console.log("add News Comments::", response);
      if (response.data?.status) {
        refresh(true);
      }
    } catch (error) {
      Store.addNotification({
        title: "Error!",
        message: "Comment delete Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      console.error(error);
      refresh(false);
    }
  };

  const onClickCancel = (e) => {
    console.log(e);
  };
  //   const handleReplyToggle = () => setShowReplyBox(!showReplyBox);

  return (
    <div
      className={`comment-item-wrapper ${
        type === "admin" && comment?.status === "hide" ? "hide" : ""
      }`}
      key={index}
    >
      <div className="ci_header">
        <div className="d-flex flex-row align-items-center">
          <div className="ci_header_name">{comment?.first_name}</div>{" "}
          {type === "admin" && (
            <div className="ci_header_date ml-2">{comment?.email}</div>
          )}
        </div>
        <div className="ci_header_date">
          {moment(comment?.created_at).startOf("minutes").fromNow()}
        </div>
      </div>

      <div className="ci_content">{comment?.comment}</div>

      <div className="d-flex flex-row justify-content-between align-items-center">
        <div className="ci_actions">
          <div
            className={"cia_like click"}
            onClick={type !== "admin" && handleLike}
          >
            {GetIconByName("like")}
            <span className="cia_count">{likes}</span>
          </div>
          <div
            className="cia_like click dislike"
            onClick={type !== "admin" && handleDislike}
          >
            {GetIconByName("dislike")}
            <span className="cia_count">{dislikes}</span>
          </div>
          {/* <div className="cia_reply click" onClick={handleReplyToggle}>
          {GetIconByName("reply")}
          <span className="cia_count">Reply</span>
        </div> */}
        </div>
        <div className={"ci__action"}>
          <Popconfirm
            placement="topLeft"
            title="Hide this Comment"
            description="Are you sure to hide this Comment?"
            onConfirm={onclickHide}
            onCancel={onClickCancel}
            okText="Yes"
            cancelText="No"
          >
            <div className={"ci__a-link"}>Hide</div>
          </Popconfirm>
          <Popconfirm
            placement="topLeft"
            title="Delete the Comment"
            description="Are you sure to delete this Comment?"
            onConfirm={onClickDelete}
            onCancel={onClickCancel}
            okText="Yes"
            cancelText="No"
          >
            <div className={"ci__a-link"}>Delete</div>
          </Popconfirm>
        </div>
      </div>

      {/* {showReplyBox && (
        <div className="ci_reply_box">
          <textarea
            className="reply_input"
            placeholder="Write your reply..."
            style={{
              width: "100%",
              marginTop: "10px",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
          <button
            style={{
              marginTop: "8px",
              padding: "6px 14px",
              background: "#007BFF",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Submit Reply
          </button>
        </div>
      )} */}
    </div>
  );
};

export default CommentItem;
